var _defs, _circle, _circle2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{stroke-width:2px}.cls-3,.cls-5{fill:none}.cls-3{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}.cls-4{stroke:none}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "add_32dp",
    transform: "translate(-3123.025 8451.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(3123.025 -8451.976)",
    style: {
      fill: "transparent"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3127.006 -8447.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(.019 .019)",
    style: {
      strokeWidth: 2,
      fill: "#fff",
      stroke: "#e3e9f3"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12,
    cy: 12,
    r: 12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12,
    cy: 12,
    r: 11
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 0h8.012v2.003H0z",
    transform: "translate(8.012 10.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1 1h6.012v.003H1z",
    transform: "translate(8.012 10.683)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1-2",
    "data-name": "Rectangle 1",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 0h8.012v2.003H0z",
    transform: "rotate(90 2.67 10.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1 1h6.012v.003H1z",
    transform: "rotate(90 2.67 10.35)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1a70c65c.svg";
export { ForwardRef as ReactComponent };